module.exports = __webpack_public_path__ + "img/newJD-downArrow.5e4fcfc8.svg";